import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

import { useIsAdmin } from "./useIsAdmin";
import { useIsHomeHealthWorkplace } from "./useIsHomeHealthWorkplace";

export function useIsHomeHealthEnabled() {
  const isAdmin = useIsAdmin();

  const isFeatureFlagEnabled = useCbhFlag(CbhFeatureFlag.HOME_HEALTH_ENABLED, {
    defaultValue: false,
  });

  const isHomeHealthWorkplace = useIsHomeHealthWorkplace();

  return (isAdmin || isFeatureFlagEnabled) && isHomeHealthWorkplace;
}
